/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyValueGuidModel } from '../../models/key-value-guid-model';

export interface MasterDataCategoryListGet$Json$Params {
}

export function masterDataCategoryListGet$Json(http: HttpClient, rootUrl: string, params?: MasterDataCategoryListGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueGuidModel>>> {
  const rb = new RequestBuilder(rootUrl, masterDataCategoryListGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<Array<KeyValueGuidModel>>;
    })
  );
}

masterDataCategoryListGet$Json.PATH = '/MasterData/CategoryList';
